// Mesmo texto gravado por sync_subscription_lead() ao cancelar a assinatura.
// Bloqueio automático por cobrança: só o superadmin reverte, o gestor não.
export const AUTO_BLOCK_REASON = 'Assinatura cancelada automaticamente';

// Usuário "excluído" é um soft delete: continua em public.users (para manter vendas,
// métricas e histórico), mas banido no Auth, com is_active=false e este motivo.
// Some das listas e não pode mais ser reativado. Mesmo texto de
// supabase/functions/_shared/accessPolicy.ts.
export const DELETED_USER_REASON = 'Usuário excluído';
